import { StyleSheet } from 'aphrodite';
import { heightOfHeader, ERROR_BAR_HEIGHT } from '../../utils/defined';

export const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: `calc(100vh - ${heightOfHeader} - ${ERROR_BAR_HEIGHT})`,
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6)',
    display:'flex',
    flexDirection:'column',
  }
});
